import {ErrorMessage} from 'angular-error-repository';

export const emailError: ErrorMessage = () => {
    return 'Please enter a valid email address';
};
